import { RootState } from "..";
import { SliceStatus } from "../utils";
import { instructorsAdapter } from "./instructorsSlice";

export const selectInstructorsLoading = (state: RootState) =>
  state.instructors.status === SliceStatus.LOADING;

export const selectInstructorsState = (state: RootState) =>
  state.instructors;

const { selectById, selectAll } = instructorsAdapter.getSelectors(
  selectInstructorsState
);

export const selectAllInstructors = selectAll;

export const selectInstructorById =
  (id: number | string) => (state: RootState) =>
    selectById(state, id);
